module.exports = __webpack_public_path__ + "img/no-thumb-flat.dfc6a3c7.png";